import { __decorate } from "tslib";
import { Mixins, Component } from 'vue-property-decorator';
import BaseSideNav from '@/components/v2/BaseSideNav.vue';
import { OVERVIEW_ROUTE, PRODUCTS_ROUTE, CATEGORIES_ROUTE, CART_SETTINGS_ROUTE, CART_PROMOS_ROUTE, DELIVERY_AREAS_ROUTE, SHIPPING_ROUTE, PAYMENT_ROUTE, PROMOS_ROUTE, ADDONS_ROUTE, APPLICATIONS_ROUTE, ORDERS_ROUTE, ORDERS_HISTORY_ROUTE, CUSTOMER_SEGMENT_ROUTE, } from '@/helpers/constants/B2bRoutes';
import { Getter } from 'vuex-class';
import { PartnershipApplicationStatus } from '@/helpers/entities/enums/v2/PartnershipApplicationStatus';
import AppDetailsMixin from '../../../helpers/vue_mixins/v2/ecommerce/AppDetailsMixin';
let B2bBundle = class B2bBundle extends Mixins(AppDetailsMixin) {
    constructor() {
        super(...arguments);
        this.childrenMenuIcon = 'keyboard_arrow_right';
        this.toggleProductsMenu = false;
        this.toggleBroadcastMenu = false;
        this.pending = PartnershipApplicationStatus.Pending;
    }
    get params() {
        const params = { appUUID: this.appUuid };
        if (!!this.appDetails && !!this.appDetails.productComponent) {
            const { productComponent } = this.appDetails;
            return Object.assign(params, { componentUUID: productComponent.uuid });
        }
        return params;
    }
    get overviewRoute() {
        return {
            icon_path: require('./assets/overview-orange.svg'),
            text: OVERVIEW_ROUTE.title,
            path: {
                name: OVERVIEW_ROUTE.name,
                params: this.params,
            },
            exact: false,
        };
    }
    get cartRoute() {
        return {
            icon_path: require('./assets/cart-orange.svg'),
            text: 'Cart',
            model: false,
            children: [
                {
                    icon: this.childrenMenuIcon,
                    text: CART_SETTINGS_ROUTE.title,
                    path: {
                        name: CART_SETTINGS_ROUTE.name,
                        params: this.params,
                    },
                    exact: false,
                },
                {
                    icon: this.childrenMenuIcon,
                    text: CART_PROMOS_ROUTE.title,
                    path: {
                        name: CART_PROMOS_ROUTE.name,
                        params: this.params,
                    },
                    exact: false,
                },
            ],
        };
    }
    get deliveryRoute() {
        return {
            icon_path: require('./assets/delivery-orange.svg'),
            text: DELIVERY_AREAS_ROUTE.title,
            path: {
                name: DELIVERY_AREAS_ROUTE.name,
                params: this.params,
            },
            exact: true,
        };
    }
    get shippingRoute() {
        return {
            icon_path: require('./assets/shipping-orange.svg'),
            text: SHIPPING_ROUTE.title,
            path: {
                name: SHIPPING_ROUTE.name,
                params: this.params,
            },
            exact: true,
        };
    }
    get paymentRoute() {
        return {
            icon_path: require('./assets/payment-orange.svg'),
            text: PAYMENT_ROUTE.title,
            path: {
                name: PAYMENT_ROUTE.name,
                params: this.params,
            },
            exact: true,
        };
    }
    get promosRoute() {
        return {
            icon_path: require('./assets/promos-orange.svg'),
            text: PROMOS_ROUTE.title,
            path: {
                name: PROMOS_ROUTE.name,
                params: this.params,
            },
            exact: true,
        };
    }
    get addonsRoute() {
        return {
            icon_path: require('./assets/addon-orange.svg'),
            text: ADDONS_ROUTE.title,
            path: {
                name: ADDONS_ROUTE.name,
                params: this.params,
            },
            exact: true,
        };
    }
    get applicationsRoute() {
        return {
            icon_path: require('./assets/application-orange.svg'),
            text: APPLICATIONS_ROUTE.title,
            path: {
                name: 'applications-by-status',
                params: { status: this.pending },
            },
            exact: false,
        };
    }
    get ordersRoute() {
        return {
            icon_path: require('./assets/order-orange.svg'),
            text: ORDERS_ROUTE.title,
            model: false,
            children: [
                {
                    icon: this.childrenMenuIcon,
                    text: ORDERS_ROUTE.title,
                    path: {
                        name: ORDERS_ROUTE.name,
                        params: { status: 'pending' },
                    },
                    exact: false,
                },
                {
                    icon: this.childrenMenuIcon,
                    text: ORDERS_HISTORY_ROUTE.title,
                    path: {
                        name: ORDERS_HISTORY_ROUTE.name,
                        params: this.params,
                    },
                    exact: false,
                },
            ],
        };
    }
    get customerSegmentRoute() {
        return {
            icon_path: require('./assets/customer-segment.svg'),
            text: CUSTOMER_SEGMENT_ROUTE.title,
            path: {
                name: CUSTOMER_SEGMENT_ROUTE.name,
                params: this.params,
            },
            exact: true,
        };
    }
    // private get broadcastRoute(): SideNavSingleMenu {
    //   return {
    //     icon_path: require('./assets/broadcast-orange.svg'),
    //     text: BROADCAST_ROUTE.title,
    //     path: {
    //       name: BROADCAST_ROUTE.name,
    //       params: this.params,
    //     },
    //     exact: true,
    //   };
    // }
    productMenu() {
        return {
            icon_path: require('./assets/campaign.svg'),
            text: 'Products',
            model: this.toggleProductsMenu,
            children: [
                {
                    icon: this.childrenMenuIcon,
                    text: PRODUCTS_ROUTE.title,
                    path: {
                        name: PRODUCTS_ROUTE.name,
                        params: this.params,
                    },
                    exact: false,
                },
                {
                    icon: this.childrenMenuIcon,
                    text: CATEGORIES_ROUTE.title,
                    path: {
                        name: CATEGORIES_ROUTE.name,
                        params: this.params,
                    },
                    exact: false,
                },
            ],
        };
    }
    get b2bMenuItems() {
        let items = [];
        if (!!this.appDetails && !!this.appDetails.productComponent) {
            items = [this.productMenu(), ...this.buildDefaultMenu()];
        }
        const menuItems = items.length >= 1 ? items : this.buildDefaultMenu();
        return [this.overviewRoute, ...menuItems];
    }
    buildDefaultMenu() {
        return [
            this.cartRoute,
            this.deliveryRoute,
            this.shippingRoute,
            this.paymentRoute,
            this.promosRoute,
            this.addonsRoute,
            this.applicationsRoute,
            this.ordersRoute,
            this.customerSegmentRoute,
        ];
    }
};
__decorate([
    Getter('appUuid')
], B2bBundle.prototype, "appUuid", void 0);
B2bBundle = __decorate([
    Component({
        components: {
            BaseSideNav,
        },
    })
], B2bBundle);
export default B2bBundle;
